import type { PocInputValidity } from 'commons/types';
import { EapCypherType, EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';

export type EapSettingsFormGeneralModel = Pick<EapSettings, 'name' | 'ssid' | 'cipherType'>;

export type EapSettingsFormGeneralValidationModel = Partial<
    Record<keyof EapSettingsFormGeneralModel, PocInputValidity>
>;

export const newEapFormValidation: EapSettingsFormGeneralValidationModel = {
    name: { state: 'valid' },
    ssid: { state: 'valid' },
};

export const EAP_CYPHER_TYPE_OPTIONS: { value: EapCypherType; label: string }[] = [
    { value: 'AES', label: 'aes' },
    { value: 'TKIP', label: 'tkip' },
    { value: 'BOTH', label: 'aes-tkip' },
];
